<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <a-tabs
        default-active-key="1"
        @change="callback"
      >
        <a-tab-pane
          key="1"
          tab="已分配"
        ></a-tab-pane>
        <a-tab-pane
          key="2"
          tab="未分配"
        ></a-tab-pane>
      </a-tabs>
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="vertical">
          <a-row :gutter="48">
            <a-col
              :md="6"
              :sm="24"
            >
              <a-form-item
                label="设备名称"
                prop="deviceName"
              >
                <a-input
                  v-model="queryParam.deviceName"
                  placeholder="请输入设备名称"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <a-col
              :md="6"
              :sm="24"
            >
              <a-form-item
                label="设备编号"
                prop="deviceCode"
              >
                <a-input
                  v-model="queryParam.deviceCode"
                  placeholder="请输入设备编号"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="在线状态" prop="onlineStatus">
                <a-select
                  v-model="queryParam.onlineStatus"
                  placeholder="请选择在线状态"
                  allow-clear
                  show-search
                >
                  <a-select-option key="1" value="1">在线</a-select-option>
                  <a-select-option key="0" value="0">离线</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="位置描述" prop="locationDescription">
                <a-input v-model="queryParam.locationDescription" placeholder="请输入位置描述" allow-clear />
              </a-form-item>
            </a-col>
            <a-col
              :md="6"
              :sm="24"
              v-if="advanced && !deviceCategorizeId"
            >
              <a-form-item
                label="设备分类"
                prop="deviceCategorizeId"
              >
                <a-select
                  v-model="queryParam.deviceCategorizeId"
                  placeholder="请选择设备分类"
                  allow-clear
                  show-search
                  :filter-option="filterOption"
                >
                  <a-select-option
                    v-for="item in deviceCategorizeList"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col
              :md="6"
              :sm="24"
              v-if="advanced && !deviceTypeId"
            >
              <a-form-item
                label="试片面积"
                prop="deviceTypeId"
              >
                <a-select
                  v-model="queryParam.deviceTypeId"
                  placeholder="请选择试片面积"
                  allow-clear
                  show-search
                  :filter-option="filterOption"
                >
                  <a-select-option
                    v-for="item in deviceTypeList"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col
              :md="6"
              :sm="24"
              v-if="advanced && !interferenceTypeId"
            >
              <a-form-item
                label="干扰类型"
                prop="interferenceTypeId"
              >
                <a-select
                  v-model="queryParam.interferenceTypeId"
                  placeholder="请选择干扰类型"
                  allow-clear
                  show-search
                  :filter-option="filterOption"
                >
                  <a-select-option
                    v-for="item in interferenceTypeList"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col
              :md="6"
              :sm="24"
              v-if="advanced && !pipelineId"
            >
              <a-form-item
                label="所属管线"
                prop="pipelineId"
              >
                <a-select
                  v-model="queryParam.pipelineId"
                  placeholder="请选择所属管线"
                  allow-clear
                  show-search
                  :filter-option="filterOption"
                >
                  <a-select-option
                    v-for="item in pipelineList"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.pipelineName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col
              :md="6"
              :sm="24"
              v-if="advanced && !customUserId"
            >
              <a-form-item
                label="所属客户"
                prop="customUserId"
              >
                <a-select
                  v-model="queryParam.customUserId"
                  placeholder="请选择所属客户"
                  allow-clear
                  show-search
                  :filter-option="filterOption"
                >
                  <a-select-option
                    v-for="item in customList"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.companyName }}
                  </a-select-option>
                </a-select>
              </a-form-item>

            </a-col>
            <a-col :md="6" :sm="24" v-if="advanced">
              <a-form-item label="城市名称" prop="city">
                <a-input v-model="queryParam.city" placeholder="请输入城市名称" allow-clear />
              </a-form-item>
            </a-col>
            <a-col
              :md="6"
              :sm="24"
              v-if="advanced"
            >
              <a-form-item
                label="选择时间"
                prop="customUserId"
              >
                <a-range-picker
                  show-time
                  v-model="value"
                  style="width: 100%;"
                  @change="handleChange"
                >
                </a-range-picker>
              </a-form-item>
            </a-col>
            <a-col
              :md="!advanced && 6 || 24"
              :sm="24"
            >
              <span
                class="table-page-search-submitButtons"
                :style="advanced && { float: 'right', overflow: 'hidden' } || {}"
              >
                <a-button
                  type="primary"
                  @click="handleQuery"
                ><a-icon type="search" />查询</a-button>
                <a-button
                  style="margin-left: 8px"
                  @click="resetQuery"
                ><a-icon type="redo" />重置</a-button>
                <a
                  @click="toggleAdvanced"
                  style="margin-left: 8px"
                >
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button
          type="primary"
          @click="$refs.createForm.handleAdd()"
          v-hasPermi="['saifuneng:device:add']"
        >
          <a-icon type="plus" />新增
        </a-button>
        <a-button
          type="primary"
          :disabled='this.distributionDisabled'
          @click="distributionClick"
          v-hasPermi="['saifuneng:device:edit']"
        >
          <a-icon type="diff" />分配
        </a-button>
        <a-button
          type="primary"
          :disabled='this.transferDisabled'
          @click="transferClick"
          v-hasPermi="['saifuneng:device:edit']"
        >
          <a-icon type="diff" />转移
        </a-button>
        <a-button type="primary" @click="$refs.defaultParamForm.handleUpdate(2)" v-hasPermi="['saifuneng:device:edit']">
          <a-icon type="edit" />默认参数
        </a-button>
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <default-param-form ref="defaultParamForm" @ok="getList" />
      <publicDate ref="public"></publicDate>
      <!-- <create-form ref="createForm" @ok="getList" /> -->
      <!-- 分配修改 -->
      <distribution-form
        ref="distributionForm"
        @ok="getList"
      />
      <!-- 转移修改 -->
      <transfer-form
        ref="transferForm"
        @ok="getList"
      />
      <!-- 参数修改 -->
      <create-param-form
        ref="createParamForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: 2000, y: 3000 }"
      >
         <span slot="onlineStatus" slot-scope="text, record">
          <a-tag v-if="record.onlineStatus == 1" color="#87d068">在线</a-tag>
          <a-tag v-if="record.onlineStatus == 0" color="#A9A9A9">离线</a-tag>
        </span>
        <span
          slot="pipelineColor"
          slot-scope="text, record"
        >
          <a-tag :color="record.pipelineColor">{{ record.pipelineColor }}</a-tag>
        </span>
        <span slot="longitudeAndLatitudeTime" slot-scope="text, record">
          {{ parseTime(record.longitudeAndLatitudeTime) }}
        </span>
        <span
          slot="createTime"
          slot-scope="text, record"
        >
          {{ parseTime(record.createTime) }}
        </span>
        <div slot="operation" slot-scope="text, record" >
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['saifuneng:device:edit']" >
            <a-icon type="edit" />修改
          </a>
          <a-divider type="vertical" v-hasPermi="['saifuneng:deviceparam:edit']" />
          <!-- 下拉按钮 -->
          <a-dropdown>
            <a class="ant-dropdown-link" @click="e => e.preventDefault()"> 更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a
                  @click="$refs.createParamForm.handleUpdate(record, undefined)"
                  v-hasPermi="['saifuneng:deviceparam:edit']"
                >
                  <a-icon type="setting" />设置参数
                </a>
              </a-menu-item>
              <a-menu-item>
                <a
                  @click="$refs.public.handleAdd(record.id, 'recorder')"
                  v-hasPermi="['saifuneng:deviceparam:edit']"
                >
                  <a-icon type="snippets" />
                  记录仪数据
                </a>
              </a-menu-item>
              <a-menu-item>
                <a
                  @click="handleDataDelete(record)"
                  v-hasPermi="['saifuneng:device:remove']"
                >
                  <a-icon type="delete" />一键清除数据
                </a>
              </a-menu-item>
              <a-menu-item>
                <a
                  @click="handleDelete(record)"
                  v-hasPermi="['saifuneng:device:remove']"
                >
                  <a-icon type="delete" />删除
                </a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </div>
      </a-table>

      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageDevice, delDevice, delDataDevice, listPipeline, customList, listDeviceCategorize, listDeviceType, listInterferenceType } from '@/api/saifuneng/recorder'
import CreateForm from './modules/CreateForm'
import DefaultParamForm from './modules/DefaultParamForm'
import DistributionForm from './modules/DistributionForm'
import TransferForm from './modules/TransferForm'
import CreateParamForm from './modules/CreateParamForm'
import { tableMixin } from '@/store/table-mixin'
import publicDate from '../../publicDate.vue'
export default {
  name: 'User',
  components: {
    CreateForm,
    DefaultParamForm,
    DistributionForm,
    TransferForm,
    CreateParamForm,
    publicDate
  },
  mixins: [tableMixin],
  props: ['customUserId', 'deviceCategorizeId', 'deviceTypeId', 'pipelineId', 'interferenceTypeId', 'city'],
  data () {
    return {
      indexCity: false,
      cityName: undefined,
      customList: [],
      pipelineList: [],
      deviceCategorizeList: [],
      deviceTypeList: [],
      interferenceTypeList: [],
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      distributionDisabled: true,
      transferDisabled: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        deviceCategorizeCode: 'recorder',
        allocationStatus: 1,
        deviceName: undefined,
        deviceCode: undefined,
        onlineStatus: undefined,
        locationDescription: undefined,
        pipelineId: undefined,
        customUserId: undefined,
        deviceCategorizeId: undefined,
        deviceTypeId: undefined,
        interferenceTypeId: undefined,
        city: undefined,
        pageNum: 1,
        pageSize: 10
      },
      value: [],
      columns: [
        {
          title: '设备名称',
          dataIndex: 'deviceName',
          ellipsis: true,
          width: 160,
          align: 'center'
        },
        {
          title: '设备编号',
          dataIndex: 'deviceCode',
          ellipsis: true,
          width: 160,
          align: 'center'
        },
        {
          title: '在线状态',
          dataIndex: 'onlineStatus',
          scopedSlots: { customRender: 'onlineStatus' },
          ellipsis: true,
          width: 100,
          align: 'center'
        },
        {
          title: 'IOT编号',
          dataIndex: 'iotCode',
          ellipsis: true,
          width: 180,
          align: 'center'
        },
        {
          title: '设备分类',
          dataIndex: 'deviceCategorizeName',
          ellipsis: true,
          width: 150,
          align: 'center'
        },
        {
          title: '试片面积',
          dataIndex: 'deviceTypeName',
          ellipsis: true,
          width: 150,
          align: 'center'
        },
        {
          title: '位置描述',
          dataIndex: 'locationDescription',
          ellipsis: true,
          width: 200,
          align: 'center'
        },
        {
          title: '最近接收数据',
          dataIndex: 'lastReceivedDataTime',
          ellipsis: true,
          width: 150,
          align: 'center'
        },
        {
          title: '干扰类型',
          dataIndex: 'interferenceTypeName',
          ellipsis: true,
          width: 150,
          align: 'center'
        },
        {
          title: '责任人',
          dataIndex: 'personResponsible',
          ellipsis: true,
          width: 150,
          align: 'center'
        },
        {
          title: '客户名称',
          dataIndex: 'customUserCompanyName',
          ellipsis: true,
          width: 200,
          align: 'center'
        },
        {
          title: '阴保数据告警',
          dataIndex: 'dataAlarm',
          ellipsis: true,
          width: 150,
          align: 'center'
        },
        {
          title: '所属管线',
          dataIndex: 'pipelineName',
          ellipsis: true,
          width: 150,
          align: 'center'
        },
        {
          title: '备注',
          dataIndex: 'remark',
          ellipsis: true,
          width: 200,
          align: 'center'
        },
        {
          title: '城市名称',
          dataIndex: 'city',
          ellipsis: true,
          width: 100,
          align: 'center'
        },
        {
          title: 'GPS定位地址',
          dataIndex: 'formattedAddress',
          ellipsis: true,
          width: 450,
          align: 'center'
        },
        {
          title: 'GPS定位时间',
          dataIndex: 'longitudeAndLatitudeTime',
          scopedSlots: { customRender: 'longitudeAndLatitudeTime' },
          ellipsis: true,
          width: 150,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          width: 150,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          fixed: 'right',
          width: '180px',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    if (this.customUserId) {
      this.queryParam.customUserId = this.customUserId
      // this.columns.pop()
    }
    if (this.deviceCategorizeId) {
      this.queryParam.deviceCategorizeId = this.deviceCategorizeId
      // this.columns.pop()
    }
    if (this.deviceTypeId) {
      this.queryParam.deviceTypeId = this.deviceTypeId
      // this.columns.pop()
    }
    if (this.pipelineId) {
      this.queryParam.pipelineId = this.pipelineId
      // this.columns.pop()
    }
    if (this.interferenceTypeId) {
      this.queryParam.interferenceTypeId = this.interferenceTypeId
      // this.columns.pop()
    }
    if (this.$route.params.deviceCode) {
      this.queryParam.deviceCode = this.$route.params.deviceCode
      // this.columns.pop()
    }
    if (this.city) {
      // this.queryParam.city = this.city
      // this.columns.pop()
    }
    this.getList()
    this.getPipelineList()
    this.getDeviceCategorizeList()
    this.getDeviceTypeList()
    this.getInterferenceTypeList()
    this.getCustomList(null)
  },
  computed: {
  },
  watch: {
  },
  methods: {
    init(city) {
      this.indexCity = true
      this.cityName = city
      this.queryParam.city = city
      this.getList()
    },
    /** 查询用户信息列表 */
    getList () {
      this.loading = true
      pageDevice(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    handleChange (e) {
      this.queryParam.createBeginTime = e[0].format('YYYY-MM-DD HH:mm:ss')
      this.queryParam.createEndTime = e[1].format('YYYY-MM-DD HH:mm:ss')
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        deviceCategorizeCode: this.queryParam.deviceCategorizeCode,
        allocationStatus: this.queryParam.allocationStatus,
        deviceName: undefined,
        deviceCode: undefined,
        onlineStatus: undefined,
        locationDescription: undefined,
        pipelineId: undefined,
        customUserId: undefined,
        deviceCategorizeId: undefined,
        deviceTypeId: undefined,
        interferenceTypeId: undefined,
        city: undefined,
        pageNum: 1,
        pageSize: 10
      }
      if (this.indexCity) {
        this.queryParam.city = this.cityName
      }
      this.value = []
      this.queryParam.customUserId = this.customUserId
      this.queryParam.deviceCategorizeId = this.deviceCategorizeId
      this.queryParam.deviceTypeId = this.deviceTypeId
      this.queryParam.pipelineId = this.pipelineId
      this.queryParam.interferenceTypeId = this.interferenceTypeId

      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
      this.distributionDisabled = this.ids.length > 0 ? false : true
      this.transferDisabled = this.ids.length > 0 ? false : true

      console.log(this.selectedRows)
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中设备编号为【' + row.deviceCode + '】的数据',
        onOk () {
          return delDevice({ "id": row.id })
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
            })
        },
        onCancel () {
          //取消清空删除ids列表
          that.id = {}
        }
      })
    },
    /** 删除按钮操作 */
    handleDataDelete (row) {
      var that = this
      this.$confirm({
        title: '确认删除所选中设备数据?',
        content: '当前选中设备编号为【' + row.deviceCode + '】的数据',
        onOk () {
          return delDataDevice({ "deviceId": row.id })
            .then(() => {
              that.onSelectChange([], [])
              // that.getList()
              that.$message.success(
                '删除成功',
                3
              )
            })
        },
        onCancel () {
          // 取消清空删除ids列表
          that.id = {}
        }
      })
    },
    getDeviceCategorizeList () {
      listDeviceCategorize().then(response => {
        this.deviceCategorizeList = response.data
      })
    },
    getDeviceTypeList () {
      listDeviceType().then(response => {
        this.deviceTypeList = response.data
      })
    },
    getInterferenceTypeList () {
      listInterferenceType().then(response => {
        this.interferenceTypeList = response.data
      })
    },
    getPipelineList () {
      listPipeline().then(response => {
        this.pipelineList = response.data
      })
    },
    getCustomList (companyName) {
      let query = {
        companyName: companyName,
        userType: '04'
      }
      customList(query).then(response => {
        this.customList = response.data.records
      })
    },
    // 页签切换
    callback (key) {
      if (key === '1') {
        this.queryParam.allocationStatus = 1
      } else {
        this.queryParam.allocationStatus = 0
      }
      this.getList()
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    distributionClick () {
      this.$nextTick(() => {
        this.$refs.distributionForm.handleDistribution(this.selectedRows)
      })
    },
    transferClick () {
      this.$nextTick(() => {
        this.$refs.transferForm.handleTransfer(this.selectedRows)
      })
    }


  }
}
</script>
<style lang="less" scoped></style>
